// CRA incrusta las REACT_APP_* en el bundle al compilar: aquí no puede ir nada secreto.
const env = (valor, porDefecto) =>
  valor && String(valor).trim() ? String(valor).trim() : porDefecto;

export const API_HOST = env(process.env.REACT_APP_API_HOST, 'https://api.previplan.co/api');
export const API_HOST_PREV = env(process.env.REACT_APP_API_HOST_PREV, 'https://previapi.previsalud.com.co/api');
export const API_HOST_DINA = env(process.env.REACT_APP_API_HOST_DINA, 'https://remotodg.previsalud.net');
export const MEMBERSHIP_URL = env(process.env.REACT_APP_MEMBERSHIP_URL, 'https://previplan.co/cuenta-de-membresia');
export const MEMBERSHIP_PROFILE_URL = env(process.env.REACT_APP_MEMBERSHIP_PROFILE_URL, 'https://www.previplan.co/cuenta-de-membresia/');
export const PREVIPLAN_HOME_URL = env(process.env.REACT_APP_PREVIPLAN_HOME_URL, 'https://www.previplan.co/');
export const BOLD_REDIRECT_URL = env(process.env.REACT_APP_BOLD_REDIRECT_URL, 'https://autogestion.previplan.co/home');
export const BOLD_DEFAULT_API_KEY = env(process.env.REACT_APP_BOLD_DEFAULT_API_KEY, 'P6xgt_T89fQX5qXvDjPCh2IuyV09fPjwNzKpsTzITp8');
export const LOCAL_SSO_TOKEN_KEY = 'localSsoToken';
export const LOCAL_SSO_TOKEN_EXP_KEY = 'localSsoTokenExp';
export const LOCAL_SSO_DURATION_MS = 50 * 60 * 1000;// 50 minutos 

export const API_KEY = env(process.env.REACT_APP_API_KEY, 'Previ2026@');
export const KEY_DINA = env(process.env.REACT_APP_KEY_DINA, 'Q0lUQTpDeXBhZzIwMjArKw==');

export const createLocalSsoToken = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const activateLocalSsoSession = (userId, remoteToken = '') => {
  const localToken = createLocalSsoToken();
  const expiresAt = Date.now() + LOCAL_SSO_DURATION_MS;

  localStorage.setItem('idUsu', String(userId));
  localStorage.setItem('loggedIn', 'true');
  localStorage.setItem('modo', '0');
  localStorage.setItem('ssoToken', String(remoteToken || ''));
  localStorage.setItem(LOCAL_SSO_TOKEN_KEY, localToken);
  localStorage.setItem(LOCAL_SSO_TOKEN_EXP_KEY, String(expiresAt));
  window.dispatchEvent(new Event('sso-session-updated'));

  return { localToken, expiresAt };
};

export const clearLocalSsoSession = () => {
  localStorage.removeItem('idUsu');
  localStorage.removeItem('loggedIn');
  localStorage.removeItem('modo');
  localStorage.removeItem('ssoToken');
  localStorage.removeItem('cedula');
  localStorage.removeItem('nombreCompleto');
  localStorage.removeItem('levelMem');
  localStorage.removeItem(LOCAL_SSO_TOKEN_KEY);
  localStorage.removeItem(LOCAL_SSO_TOKEN_EXP_KEY);
  window.dispatchEvent(new Event('sso-session-updated'));
};

export const getLocalSsoExpiration = () => {
  const rawValue = localStorage.getItem(LOCAL_SSO_TOKEN_EXP_KEY);
  if (!rawValue) {
    return null;
  }
  const expiresAt = Number(rawValue);
  return Number.isNaN(expiresAt) ? null : expiresAt;
};
